// extracted by mini-css-extract-plugin
module.exports = {"skipbutton":"button_skipbutton__jKFEy","widgetButton":"button_widgetButton__L7_1D"};